import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import app from '../Assets/app.jpg';
import mobileIcon from '../Assets/phone.svg';
import Container from 'react-bootstrap/Container';


//Half picture, half mobile dev explanation. Animation added. see data-aos

class HalfSection extends React.Component {
    render(){
        return(
            <div className="spacing yuckySection services" >
                <Container  >
                <Row >
                  
                    <Col md={5} className="mergeBox1 div1 " data-aos={"fade"} >
                        <div style={{width: "100%"}}>
                            <img src={mobileIcon} className="serviceIcon" />
                        </div>
                

      
                        <h2 className="innerBoxTitle">
                            Mobile Development
                        </h2>
                        <div className="innerBoxText">
                            We design, develop and test your apps, before launching them. We take care of the full development work so you can focus on your business. 
                        </div>
                    </Col>
                    <Col md={7} className="noPadMob">
                       
            

                        <video className="imagesFront div2 appImage" autoPlay muted playsInline loop data-aos={"fade"}>
                                <source src="https://compilelabs.s3.ca-central-1.amazonaws.com/videos/movieCompileLabs.mp4" type="video/mp4" />
                        </video>
                    </Col>

   
                </Row>
                </Container>
            </div>
        );
    }

}



export default HalfSection;